import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "legacy-extensibility"
    }}>{`Legacy Extensibility`}</h1>
    <p>{`While UXP is the recommended platform for all plugin developers to build on, Photoshop 2022 continues to support legacy extensibility features.`}</p>
    <h2 {...{
      "id": "extendscript"
    }}>{`ExtendScript`}</h2>
    <p>{`The UXP `}<a parentName="p" {...{
        "href": "../../ps_reference/"
      }}>{`Photoshop DOM API`}</a>{` aims to be the evolution of the `}<a parentName="p" {...{
        "href": "https://www.adobe.com/devnet/photoshop/scripting.html"
      }}>{`ExtendScript`}</a>{` DOM. There are currently no plans to remove ExtendScript support from Photoshop.`}</p>
    <p>{`Even though the ExtendScript Toolkit IDE is no longer maintained due to its reliance on 32-bit architectures, you can develop ExtendScripts using the `}<a parentName="p" {...{
        "href": "https://marketplace.visualstudio.com/items?itemName=Adobe.extendscript-debug"
      }}>{`Visual Studio plugin for ExtendScript`}</a>{`.`}</p>
    <p>{`ExtendScript developers wishing to migrate their plugins onto the UXP platform should consult the `}<a parentName="p" {...{
        "href": "./uxp_for_you/uxp_for_extendscript_devs"
      }}>{`UXP for ExtendScript Developers`}</a>{`.`}</p>
    <h2 {...{
      "id": "cep-common-extensibility-platform"
    }}>{`CEP (Common Extensibility Platform)`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://www.adobe.io/apis/creativecloud/cep.html"
      }}>{`Common Extensibility Platform`}</a>{`, introduced as a way of extending Creative Suite applications, will continue to be supported in Photoshop.`}</p>
    <p>{`CEP developers wishing to migrate their plugins onto the UXP platform should consult the `}<a parentName="p" {...{
        "href": "./uxp_for_you/uxp_for_cep_devs"
      }}>{`UXP for CEP Developers`}</a>{`.`}</p>
    <h2 {...{
      "id": "native-c-plugins"
    }}>{`Native C++ Plugins`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.adobe.com/devnet/photoshop/sdk.html"
      }}>{`Plugins using native C++`}</a>{` are an important part of the Photoshop extensibility ecosystem and will continue to be supported.`}</p>
    <p>{`A communication bridge suite was created to allow C++ plugins running under Photoshop to communicate with UXP plugins. See `}<a parentName="p" {...{
        "href": "../ps_reference/media/cpp-pluginsdk"
      }}>{`Communication with C++ Plugin SDK`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      